import React, { Component } from 'react';
import { DashboardLayout } from '../../../layout';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { Link } from 'react-router-dom';
import { userActions } from '../../../../common/redux/actions';
import Rating from '@material-ui/lab/Rating';
import { IconButton } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { Pagination } from 'react-bootstrap';
import { alertSelectors } from '../../../../common/redux/selectors';
import { confirmAlert } from 'react-confirm-alert';

class UserFavorites extends Component {

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(userActions.favorite());
    }

    markAsFavorite = (item) => {
        const { dispatch } = this.props;
        confirmAlert({
            title: `Please confirm to remove`,
            message: `Are you sure to remove this favorite list`,
            buttons: [
                {
                    label: 'No',
                    onClick: () => dispatch(alertSelectors.error("You have not accepted the request."))
                },
                {
                    label: 'Yes',
                    onClick: () => dispatch(userActions.favorite("DELETE", null, {item_id: item.id}))
                }
            ]
        });
    }

    onChangePage = (event, page) => {
        const { dispatch } = this.props;
        dispatch(userActions.favorite("GET", null, {page: page}));
    }

    render() {
        const { favorites } = this.props;
        const favoriteItems = (favorites && favorites.favorites) ? favorites.favorites : null;
        const pagination = (favorites && favorites.pagination) ? favorites.pagination : null;
        //console.log('favorites', favoriteItems);
        return (<DashboardLayout>
            <section className="favorite-page">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="post-box">
                            <h2 className="mb-0 page-title">Favorite Tutors</h2>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {(favoriteItems === null) ? <>
                        {[1,2,3,4].map((item) =>
                            <div className="col-md-3" key={`loading-${item}`}>
                                <div className="arrival-box">
                                    <div className="image">
                                        <Skeleton variant="circle" width={'100%'} height={200} />
                                    </div>
                                    <div className="caption">
                                        <Skeleton />
                                        <Skeleton />
                                        <Skeleton />
                                        <Skeleton width="80%" />
                                        <Skeleton width="70%" />
                                        <Skeleton width="60%" />
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                    : <> 
                        {favoriteItems && favoriteItems.map(item => 
                            <div className="col-lg-3 col-md-9 mb-4" key={item.id}>
                                <div className="arrival-box">
                                    <div className="image text-center">
                                        <img className="img-circle" src={(item.favorites.avatar === null) ? '/images/dummy-profile.png' : item.favorites.avatar && item.favorites.avatar.thumb} alt={item.favorites && item.favorites.name} />
                                    </div>
                                    <div className="caption">
                                        <h5><Link to={`/tutor/view/${item.favorite_id}`}>{item.favorites && item.favorites.name}</Link></h5>  
                                        <div className="rating text-center d-flex">
                                            <span className="star">
                                                <Rating name="size-medium" defaultValue={parseFloat(item.favorites && item.favorites.avg_rating)} readOnly />
                                            </span>
                                            <span className="rate"> ({item.favorites && item.favorites.avg_rating}) {item.favorites && item.favorites.count_rating} Ratings</span>
                                        </div>
                                        <h6 className="text-primary text-truncate">
                                            {item.favorites.userCatalogs && item.favorites.userCatalogs.map(subject => subject.title).join(', ')}
                                        </h6>
                                        <p className="address">{item.favorites.country_code && item.favorites.country_code.name}</p>
                                        <div className="wishlist justify-content-between d-flex">
                                            {/* <span className="badge badge-info">$15.00 / Session</span> */}
                                            <IconButton className="favorite p-0" aria-label="Favorite" onClick={() => this.markAsFavorite(item)}>
                                                <i className={`fas fa-heart text-primary`}></i>
                                            </IconButton>
                                        </div>    
                                    </div>
                                </div>
                            </div>
                        )}
                        {(favoriteItems && favoriteItems.length === 0) && <div className="col-12 py-3 text-left">Favorite not found</div>}
                    </>}
                    <div className="col-12 text-center">
                        <div className="d-flex justify-content-center">
                            {pagination && pagination.totalCount > 19 && <>
                                <Pagination count={Math.ceil(parseInt(pagination && pagination.totalCount) / 20)} defaultPage={1} siblingCount={0} size="large" color="primary" onChange={this.onChangePage} />
                            </>}
                        </div>
                    </div>
                </div>
            </section> 
        </DashboardLayout>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);

const favoritesSelector = createSelector(
    state => state.favorites,
    favorites => favorites
);

const mapStateToProps = createSelector(
    processSelector,
    favoritesSelector,
    (process, favorites) => ({
        process, favorites
    })
);

export default connect(mapStateToProps)(UserFavorites);